import React, { useEffect, useState } from "react";
import { useFormikContext } from "formik";
import { useSelectedPlanContext } from "../../../../contexts/SelectedPlanContext";
import { usePageSettings } from "../../../../contexts/PageSettingsContext";
import BaremetalCheckoutFields from "./service-fields/BaremetalCheckoutFields";
import VpsCheckoutFields from "./service-fields/VpsCheckoutFields";
import ColoCheckoutFields from "./service-fields/ColoCheckoutFields";
import PaymentCyclesRadioList from "./PaymentCycles";
import { useCheckout } from "../../../../contexts/CheckoutPageContext";
import WebHostingCheckoutFields from "./service-fields/WebHostingCheckoutFields";

const CheckoutConfigurationForm = ({ addons, addAddon, removeAddon }) => {
	const { translations } = usePageSettings();
	const { currency } = usePageSettings();
	const { selectedPlan } = useSelectedPlanContext();
	const { values, setFieldValue } = useFormikContext();
	const { orderCount } = useCheckout();
	const addonIds = gatherAddonIds(values.configuration);

	// Preload from Formik values which is monthly
	const [selectedPaymentCycle, setSelectedPaymentCycle] = useState(values.configuration.paymentCycle || "");

	const handleAddonChange = (addonType, addonId, addonName) => {
		if (addonId) {
			addAddon(addonType, addonId, addonName); // Add selected addon to the shared state
		} else {
			removeAddon(addonType); // Remove addon if deselected
		}
	};

	useEffect(() => {
		setSelectedPaymentCycle(values.configuration.paymentCycle); // Sync payment cycle state with Formik on mount
	}, [values.configuration.paymentCycle]);

	const handlePaymentCycleChange = (value) => {
		setSelectedPaymentCycle(value);
		setFieldValue("configuration.paymentCycle", value); // Update parent's Formik field value
	};

	// Decide which fields to show based on the service
	const renderServiceFields = () => {
		switch (selectedPlan.service) {
			case "vps":
				return <VpsCheckoutFields handleAddonChange={handleAddonChange} />;
			case "baremetal":
				return <BaremetalCheckoutFields handleAddonChange={handleAddonChange} />;
			case "colocation":
				return <ColoCheckoutFields handleAddonChange={handleAddonChange} />;
			case "webhosting":
				return <WebHostingCheckoutFields />;
			default:
				// If the service is not available, return something
				return null;
		}
	};

	return (
		<div className="flex flex-col gap-4 px-4 md:px-0">
			{renderServiceFields()}
			{/* Payment Methods */}
			<div className="border-t border-ipxon-dark-gray">
				<label className="text-zinc-400 flex flex-col text-sm font-bold my-7 gap-2 capitalize">
					<span className="text-zinc-200 text-base capitalize font-bold">
						{translations["ConfigServerBillingCycleTitle"]}
					</span>
					<span className="text-zinc-500 text-sm font-normal">
						{translations["ConfigServerBillingCycleSubtitle"]}
					</span>
				</label>
				{/* Use PaymentCycles */}
				<PaymentCyclesRadioList
					currency={currency}
					selectedPaymentCycle={selectedPaymentCycle}
					onPaymentCycleChange={handlePaymentCycleChange}
					addons={addonIds}
					count={orderCount}
				/>
			</div>
		</div>
	);
};

export default CheckoutConfigurationForm;

export function gatherAddonIds(configuration) {
	//This function prepares an array of ids to be sent to the payment cycles to fullfill
	const addonIds = [];

	if (configuration.os?.id) {
		addonIds.push(configuration.os.id);
	}
	if (configuration.additionalIp?.id) {
		addonIds.push(configuration.additionalIp.id);
	}
	// Only add if bgp.enabled is true, or if you want to always push if id is present
	if (configuration.bgp?.enabled && configuration.bgp.id) {
		addonIds.push(configuration.bgp.id);
	}
	// Add more fields from other services as needed (For example if BGP/Storage/Ultraproxy have extra addons, add them here.)

	return addonIds;
}
